import React, { useEffect, useState } from 'react';
import { AlignLeftOutlined, AlignRightOutlined } from '@ant-design/icons';
import { NavBar, Popup } from 'antd-mobile'
import { withLocalize } from "react-localize-redux";
import { Row, Col, Layout as AntLayout } from 'antd';
import Drawar from '../pages/drawar'
import Navigation from '../pages/navigation';



const { Sider, Content } = AntLayout;

const Layout = ({ children, activeLanguage, title }) => {

    const [visible, setVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    return (
        <>

            {!isMobile && (
                // <Sider width={250} style={{ backgroundColor: '#f5f7fa' }}>
                <Navigation />
                // </Sider>
            )}
            {isMobile && (
                <NavBar back={activeLanguage.code === 'en' ? <AlignLeftOutlined /> : <AlignRightOutlined />} onBack={() => setVisible(true)} backArrow={false} >
                    {/* {title} */}
                </NavBar>
            )}
            <Row justify="center" style={{ minHeight: '50vh', alignItems: 'center', padding: '24px' }}>
                <Col xs={0} sm={8} md={8} lg={8} xl={8} ></Col>
                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',

                    }}
                        className="bg-image"
                    >
                        <div style={{ marginTop: '20px', fontSize: '32px', fontWeight: 'bold', textAlign: 'center' }}>
                            {title}
                        </div>
                        {children}
                    </div>
                </Col>
                <Col xs={0} sm={8} md={8} lg={8} xl={8} ></Col>
            </Row>
            {isMobile && (
                <Popup visible={visible} onMaskClick={() => { setVisible(false) }} position={activeLanguage.code === 'en' ? 'left' : 'right'} bodyStyle={{ minWidth: '70vw', backgroundColor: 'rgb(245, 247, 250)' }} >
                    <Drawar />
                </Popup>
            )}
        </>
    );

}

export default withLocalize(Layout);